import { Choice, Question } from '@generated/graphql';
import { getAccessToken } from '../services/authentication';

const createSignedUrl = async (objectKey: string): Promise<string> => {
  // objectKey is the path to the file/object in S3
  const jwtToken = await getAccessToken();

  const response = await fetch(`${import.meta.env.REST_API_URL}/get-signed-url`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: jwtToken ? `Bearer ${jwtToken}` : '',
    },
    body: JSON.stringify({ objectKey }),
  });
  const data = (await response.json()) as { signedUrl: string };
  return data.signedUrl;
};

const buildImagePath = (item: Question | Choice): string => {
  const THUMBNAIL_PATH = 'images/questions';
  const filename = item.thumbnailFilename?.trim();

  // try to build the filename from the item and parents.
  // he issue is parent and grandparent are not available to be passed in the props
  //
  //   const filename = item.thumbnailFilename?.trim() || item.text.replace(/\s+/g, '_').toLowerCase();
  // if ('thumbnailFilename' in item) {
  //   prefix = item.__typename === 'Question' ?
  // }
  // // eslint-disable-next-line no-underscore-dangle
  // if (item.__typename === 'Question') {
  //   filename = question.thumbnailFilename
  //     ? question.thumbnailFilename
  //     : question.text.replace(/\s+/g, '_').toLowerCase();
  // }
  // if (choice) {
  //   filename = choice.thumbnailFilename
  //     ? choice.thumbnailFilename
  //     : choice.text.replace(/\s+/g, '_').toLowerCase();
  // }

  return `${THUMBNAIL_PATH}/${filename}`;
};

export { createSignedUrl, buildImagePath };
